import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { CONSOLE_TABS } from '../../constants/consoleConstants';

export default function ConsoleTabsNav() {
    const { pathname } = useLocation();

    return (
        <div className="flex flex-wrap items-center gap-2 mb-6 border-b border-gray-100 pb-4">
            {CONSOLE_TABS.map(tab => {
                const Icon = tab.icon;
                const isActive = pathname === tab.path || (pathname.startsWith(tab.path + '/') && tab.key !== 'dashboard');
                
                return (
                    <NavLink
                        key={tab.key}
                        to={tab.path}
                        className={`group flex items-center gap-2 px-4 py-2.5 rounded-lg text-lg font-semibold transition-all ${
                            isActive 
                                ? 'bg-sb-primary text-white shadow-md shadow-blue-500/20' 
                                : 'bg-white border border-gray-200 text-gray-600 hover:border-blue-200 hover:bg-blue-50 hover:text-blue-700'
                        }`}
                        end={tab.key === 'dashboard'} // 대시보드는 정확히 일치할 때만 활성화
                    >
                        <Icon size={16} className={isActive ? 'text-white' : 'text-gray-400 group-hover:text-blue-500'} />
                        {tab.label}
                        {tab.stage && (
                            <span className={`text-sm px-1.5 py-0.5 rounded-md ${
                                isActive ? 'bg-white/20 text-white' : 'bg-gray-100 text-gray-500 group-hover:bg-blue-100 group-hover:text-blue-600'
                            }`}>
                                {tab.stage}
                            </span>
                        )}
                    </NavLink>
                );
            })}
        </div>
    );
}
